export const ATTENTION_SHAPE_NAME = 'ATTENTION_SHAPE';
export const ATTENTION_LAYER_NAME = 'AttentionLayer';
export const ATTENTION_NODE_PREDICATES = 'attentionNodePredicates';
